var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorMovil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 625,
    viewBox: "0 0 396 625",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.057 20.3399C247.615 -25.4249 198 20.3399 198 20.3399C198 20.3399 148.5 66.1048 99.0573 20.3399C49.6146 -25.4249 0 20.3399 0 20.3399V625H396V20.3399C396 20.3399 346.5 66.1048 297.057 20.3399Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorMovil);
export default __webpack_public_path__ + "static/media/Vector_movil.450f4ca195c123c6a29032cfb57f4762.svg";
export { ForwardRef as ReactComponent };